import React from 'react';
import {UserInsights} from "types/User";
import StatList from "components/StatList";
import StatBoxSimple from "components/StatBoxSimple";
import Divider from "components/Divider";
import StackedList from "components/StackedList";
import StackedListItem from "components/StackedListItem";
import Link from "components/Link";
import {formattedDate} from "services/date";
import Card from "components/Card";
import {useQuery} from "react-query";
import ngage from "services/ngage";

// Types ----

type VouchersCardProps = {
  userId: number
  insights?: UserInsights | null
}

// Component ----

function VouchersCard({userId, insights}: VouchersCardProps) {

  const {data: vouchers, isLoading: isLoadingVouchers} = useQuery(
    ['vouchers.all', {holder: userId}],
    () => ngage.vouchers.filtered({holder: userId}),
    {keepPreviousData: true}
  )

  return (
    <Card heading="Vouchers" isLoading={isLoadingVouchers}>
      <StatList columns={2}>
        <StatBoxSimple name='Total' stat={insights?.engagement.all_vouchers}/>
        <StatBoxSimple name='Claimed' stat={insights?.engagement.used_vouchers}/>
        <StatBoxSimple name='Valid' stat={insights?.engagement.valid_vouchers}/>
      </StatList>

      {!vouchers?.data?.length ? (
        <div className="mt-6 flow-root">
          <Divider/>
          <p className="text-sm text-gray-400 mt-6">No vouchers</p>
        </div>
      ) : (
        <div className="mt-6">
          <StackedList>
            {vouchers?.data?.map((voucher) => (
              <StackedListItem hasLink={true} key={voucher.id}>
                <Link to={`/vouchers/${voucher.id}`}>
                  <p className="truncate text-sm font-medium text-gray-500">{voucher.offer?.name}</p>

                  <div
                    className="mt-4 grid grid-cols-1 gap-1 font-normal text-sm text-gray-900">
                    <p>
                      <span className="mr-1.5 text-gray-400">Incentive:</span>
                      {voucher.offer?.incentive}
                    </p>
                    <p>
                      <span className="mr-1.5 text-gray-400">Uses remaining:</span>
                      {voucher.uses_remaining ?? 0}
                    </p>
                    <p>
                      <span className="mr-1.5 text-gray-400">Expires:</span>
                      {voucher.expires_at ? formattedDate(voucher.expires_at) : 'Never'}
                    </p>
                  </div>
                </Link>
              </StackedListItem>
            ))}
          </StackedList>
        </div>
      )}
    </Card>
  );
}

// Export ----

export default VouchersCard;